export function UnreadIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_221_6418)">
        <path
          d="M10.7333 3.5H6.5C4.84315 3.5 3.5 4.84315 3.5 6.5V13.5C3.5 15.1569 4.84315 16.5 6.5 16.5H13.5C15.1569 16.5 16.5 15.1569 16.5 13.5V9.26667"
          stroke="current"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <circle cx="15" cy="5" r="2" fill="current" />
      </g>
      <defs>
        <clipPath id="clip0_221_6418">
          <rect width="20" height="20" fill="current" />
        </clipPath>
      </defs>
    </svg>
  );
}
